import React, { useContext, useEffect, useState } from "react";
import { EmptyFilterCondition, EmptyFilterConditionGroup, filterConditionOperators, operatorHasRValue } from "./filter-condition-utils";
import classNames from "classnames";
import { ButtonComponent, IconButton, Select } from "uxp/components";
import cloneDeep from 'lodash-es/cloneDeep.js';
import { QueryBuilderContext } from "@query-builder/QueryBuilderContext";
import './FilterConditionsEditor.scss';
import { DEPillInput } from "../PillInput/DEPillInput";
export const FilterConditionsEditor = props => {
    const { filterConditions, onChange, attributes, onChnageConfitions, query } = props;
    const context = useContext(QueryBuilderContext);
    const $L = (key) => context.uxpContext.$L(key);
    const [conditions, setConditions] = useState(filterConditions);
    useEffect(() => {
        setConditions(filterConditions);
    }, [filterConditions]);
    function addCondition() {
        const _fcs = cloneDeep(conditions);
        _fcs.Conditions.push(cloneDeep(EmptyFilterCondition));
        setConditions(_fcs);
        handleConditionChanges(_fcs);
    }
    function addConditionGroup() {
        const _fcs = cloneDeep(conditions);
        _fcs.Conditions.push(cloneDeep(EmptyFilterConditionGroup));
        setConditions(_fcs);
        handleConditionChanges(_fcs);
    }
    function updateCondition(updated) {
        setConditions(updated);
        handleConditionChanges(updated);
    }
    function commitChanges() {
        onChange(conditions);
    }
    function handleConditionChanges(conds) {
        onChnageConfitions(conds);
    }
    return React.createElement("div", { className: "lqe-fce-d405c35e" },
        React.createElement(FilterConditionGroupEditor, { group: conditions, onChange: updateCondition, attributes: attributes, onRemove: () => { }, isParent: true, query: query, "$L": $L }),
        React.createElement("div", { className: "lqe-fce__footer-d405c35e" },
            React.createElement("div", { className: "lqe-fce__footer-left-d405c35e" },
                React.createElement("div", { className: "lqe-fce__add-btn-d405c35e", onClick: addCondition }, $L('lqe.filter.add-condition')),
                React.createElement("div", { className: "lqe-fce__add-btn-d405c35e", onClick: addConditionGroup }, $L('lqe.filter.add-group'))),
            React.createElement("div", { className: "lqe-fce__footer-right-d405c35e" },
                React.createElement(ButtonComponent, { title: $L('lqe.filter.apply'), onClick: commitChanges, leftIcon: "fas check-circle" }))));
};
const FilterConditionGroupEditor = props => {
    var _a;
    const { group, onChange, onRemove, attributes, isParent, query, $L: $LProp } = props;
    const context = useContext(QueryBuilderContext);
    const $L = $LProp || ((key) => context.uxpContext.$L(key));
    function addCondition() {
        const _fcs = cloneDeep(group);
        _fcs.Conditions.push(cloneDeep(EmptyFilterCondition));
        onChange(_fcs);
    }
    function addConditionGroup() {
        const _fcs = cloneDeep(group);
        _fcs.Conditions.push(cloneDeep(EmptyFilterConditionGroup));
        onChange(_fcs);
    }
    function renderConditions() {
        function removeCondition(index) {
            const _group = cloneDeep(group);
            const filtered = _group.Conditions.filter((_, i) => i !== index);
            onChange(Object.assign(Object.assign({}, _group), { Conditions: filtered }));
        }
        function updateCondition(index, condition) {
            const _group = cloneDeep(group);
            const updated = _group.Conditions.map((c, i) => i == index ? condition : c);
            onChange(Object.assign(Object.assign({}, _group), { Conditions: updated }));
        }
        function renderLabel(index) {
            if (index == 0)
                return $L('lqe.filter.where');
            if (index == 1)
                return React.createElement(Select, { selected: group.All ? 'and' : 'or', onChange: s => onChange(Object.assign(Object.assign({}, cloneDeep(group)), { All: s == 'and' })), options: [{
                            label: $L('lqe.filter.and'),
                            value: 'and'
                        }, {
                            label: $L('lqe.filter.or'),
                            value: 'or'
                        }], className: "lucy-query-engine-input-small-d405c35e", dropdownClassname: "lucy-query-engine-dropdown" });
            if (index > 1)
                return group.All ? $L('lqe.filter.and') : $L('lqe.filter.or');
        }
        return React.createElement(React.Fragment, null, group.Conditions.map((c, i) => {
            const isGroup = c.hasOwnProperty('All');
            return React.createElement("div", { className: "lqe-fce__condition-row-d405c35e", key: i },
                React.createElement("div", { className: "lqe-fce__condition-lbl-d405c35e" }, renderLabel(i)),
                React.createElement("div", { className: "lqe-fce__condition-d405c35e" }, isGroup ? React.createElement(FilterConditionGroupEditor, { group: c, onChange: updated => updateCondition(i, updated), onRemove: () => removeCondition(i), attributes: attributes, query: query, "$L": $L }) : React.createElement(FilterConditionEditor, { condition: c, onChange: updated => updateCondition(i, updated), onRemove: () => removeCondition(i), attributes: attributes, query: query, "$L": $L })));
        }));
    }
    const groupEl = React.createElement("div", { className: classNames("lqe-fce__group-d405c35e", {
            "lqe-fce__group--parent-d405c35e": isParent
        }) },
        group.Conditions.length > 1 && React.createElement("div", { className: "lqe-fce__group-hd-d405c35e" },
            React.createElement("div", { className: "lqe-fce__group-title-d405c35e" },
                group.All ? $L('lqe.filter.all') : $L('lqe.filter.one'),
                " ",
                $L('lqe.filter.conditions-true'))),
        React.createElement("div", { className: "lqe-fce__group-body-d405c35e" }, ((_a = group.Conditions) === null || _a === void 0 ? void 0 : _a.length) > 0 ? React.createElement(React.Fragment, null, renderConditions()) : React.createElement("div", { className: "lqe-fce__empty-d405c35e" }, $L('lqe.filter.no-conditions'))),
        !isParent && React.createElement("div", { className: "lqe-fce__group-footer-d405c35e" },
            React.createElement("div", { className: "lqe-fce__add-btn-d405c35e", onClick: addCondition }, $L('lqe.filter.add-condition')),
            React.createElement("div", { className: "lqe-fce__add-btn-d405c35e", onClick: addConditionGroup }, $L('lqe.filter.add-group'))));
    if (isParent)
        return groupEl;
    return React.createElement("div", { className: "lqe-fce__condition-body-d405c35e" },
        groupEl,
        React.createElement("div", { className: "lqe-fce__delete-btn-d405c35e" },
            React.createElement(IconButton, { type: 'delete', variant: 'danger', onClick: onRemove })));
};
const FilterConditionEditor = props => {
    const { condition, onChange, onRemove, attributes, query } = props;
    function onValueChange(value) {
        onChange(Object.assign(Object.assign({}, condition), { Value: value }));
    }
    return React.createElement("div", { className: "lqe-fce__condition-body-d405c35e" },
        React.createElement("div", { className: "lqe-fce__editor-d405c35e" },
            React.createElement("div", { className: "lqe-fce__input-d405c35e" },
                React.createElement(Select, { selected: condition.Attribute || '', onChange: s => onChange(Object.assign(Object.assign({}, condition), { Attribute: s })), options: attributes, labelField: "name", valueField: "name", className: "lucy-query-engine-input-d405c35e", dropdownClassname: "lucy-query-engine-dropdown" })),
            React.createElement("div", { className: "lqe-fce__input-d405c35e" },
                React.createElement(Select, { selected: condition.Operator || '', onChange: s => onChange(Object.assign(Object.assign({}, condition), { Operator: s })), options: Object.values(filterConditionOperators), className: "lucy-query-engine-input-d405c35e", dropdownClassname: "lucy-query-engine-dropdown" })),
            operatorHasRValue(condition.Operator) && React.createElement("div", { className: "lqe-fce__value-wrap-d405c35e" },
                React.createElement(DEPillInput, { value: String(props.condition.Value), onChange: onValueChange, query: query }))),
        React.createElement("div", { className: "lqe-fce__delete-btn-d405c35e" },
            React.createElement(IconButton, { type: 'delete', variant: 'danger', onClick: onRemove })));
};
